<template>
  <footer class="flex flex-wrap py-8 px-16 mt-2 items-center justify-between bg-black-cvre border-t">
    <div class="w-full lg:w-auto lg:mr-6 mb-4 lg:mb-0 text-white text-center">© 2020 Nicko Valentino</div>
    <div class="flex flex-col lg:flex-row items-center w-full lg:w-auto">
      <div class="mx-auto lg:mx-0 lg:ml-auto">
        <a target="_blank" class="inline-block mt-0 text-white" href="https://www.instagram.com/thecvrepeople/">Instagram</a>

      </div>
    </div>
  </footer>
</template>

<script>
export default {
      name:'Footer'
}
</script>